// src/hooks/useConnector.ts - Return default connector instead of null
import { useMemo } from 'react';
import { getItemByIdOrThrow } from 'src/utils';
import { useScene } from 'src/hooks/useScene';
import { CONNECTOR_DEFAULTS } from 'src/config';

export const useConnector = (id?: string) => {
  const { connectors } = useScene();

  const connector = useMemo(() => {
    // 🔧 FIX: Handle undefined id and empty connectors array
    if (!id || !connectors || connectors.length === 0) {
      console.warn(`Invalid connector ID or empty connectors array: ${id}`);
      // Return a default connector object to prevent TypeScript errors
      return {
        ...CONNECTOR_DEFAULTS,
        id: id || 'unknown',
        path: {
          tiles: [],
          rectangle: { from: { x: 0, y: 0 }, to: { x: 0, y: 0 } }
        },
        anchors: [],
        description: '',
        color: '#3b82f6',
        width: 10,
        style: 'SOLID' as const,
        arrowType: 'SINGLE' as const
      };
    }

    try {
      return getItemByIdOrThrow(connectors, id).value;
    } catch (error) {
      console.warn(`Connector not found: ${id}`, error);
      // Return a default connector object to prevent TypeScript errors
      return {
        ...CONNECTOR_DEFAULTS,
        id: id,
        path: {
          tiles: [],
          rectangle: { from: { x: 0, y: 0 }, to: { x: 0, y: 0 } }
        },
        anchors: [],
        description: '',
        color: '#3b82f6',
        width: 10,
        style: 'SOLID' as const,
        arrowType: 'SINGLE' as const
      };
    }
  }, [connectors, id]);

  return connector;
};